import React, { useEffect } from "react";
import { useField, useFormikContext } from "formik";
import styles from "./SelectInput.module.css";
import { FormField, Select, SelectOption } from "@justworkshr/milo-form";
interface optionType {
  value: string;
  name: string;
  description: string;
}
interface ISelectInputProps {
  name: string;
  label: string;
  onChange?: () => void;
  placeholder: string;
  onBlur?: () => void;
  onFocus?: () => void;
  options: any;
  required?: boolean;
  message?: string;
  className?: string;
  disabled?: boolean;
  hiddenOptions?: string[];
  fieldRefs?: React.MutableRefObject<{
    [key: string]: HTMLInputElement | null;
  }>;
}

const SelectInput = ({ ...props }: ISelectInputProps): JSX.Element => {
  const {
    name,
    label,
    placeholder,
    options,
    message,
    required = true,
    className,
    hiddenOptions = [],
    disabled,
    fieldRefs,
  } = props;
  const [field, meta] = useField(props);
  const { setFieldTouched } = useFormikContext();

  useEffect(() => {
    if (meta.initialTouched === false) {
      setFieldTouched(name, false);
    }
  }, [name, meta.initialTouched, setFieldTouched]);

  return (
    <div
      className={`${styles.container} ${className}`}
      ref={(el: HTMLInputElement | null) => {
        if (fieldRefs?.current) {
          fieldRefs.current[name] = el as HTMLInputElement | null;
        }
      }}
    >
      <FormField
        required={required}
        message={message}
        label={label}
        aria-labelledby={!label ? "select-input" : undefined}
        error={meta.touched ? meta.error : ""}
      >
        <Select
          data-testid={name}
          id={name}
          disabled={disabled}
          {...field}
          onBlur={() => {
            setFieldTouched(name, true);
          }}
        >
          <SelectOption
            data-testid={`${name}-option-${placeholder}`}
            value=""
            disabled
          >
            {placeholder}
          </SelectOption>
          {options &&
            options.map((option: optionType) => {
              return (
                <SelectOption
                  key={option.value}
                  value={option.value}
                  data-testid={`${name}-option-${option.value}`}
                  hidden={hiddenOptions.includes(option.value)}
                >
                  {option.name || option.description}
                </SelectOption>
              );
            })}
        </Select>
      </FormField>
    </div>
  );
};

export default SelectInput;
